<template>
    <div class="gallery-item">
        <div class="gallery-item-inner">
            <a href="">
                <div class="image"
                     v-bind:style="{ backgroundImage: 'url(' + data.image + ')' }"
                     style="background-position: center;
                     background-size: cover;">
                    <img class="hidden" :src="data.image" alt="">
                </div>
            </a>
            <div class="content">
                <button>{{ data.button_text }}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'AdItem',
  props: ['data']
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/AdItem.vue